import { doAttention } from '@/attention';
export function wobble(el, duration = undefined, options = {}) {
    return doAttention(el, 'wobble', duration, options);
}
//# sourceMappingURL=wobble.js.map